export default "__VITE_ASSET__Bn9Frjxr__ 640w, __VITE_ASSET__iD5oRmXd__ 1024w";